"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDeviceV2 = exports.DeviceV2 = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const shared_1 = require("@getgreenline/shared");
const device_1 = require("./device");
class DeviceV2 extends device_1.Device {
}
exports.DeviceV2 = DeviceV2;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)()
], DeviceV2.prototype, "deviceMetadata", void 0);
class UpdateDeviceV2 {
}
exports.UpdateDeviceV2 = UpdateDeviceV2;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "password", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "terminalPort", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "terminalIpAddress", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.Validate)(shared_1.MaxNumberLength, [5])
], UpdateDeviceV2.prototype, "merrcoCompanyNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.Validate)(shared_1.MaxNumberLength, [8])
], UpdateDeviceV2.prototype, "merrcoMerchantNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.Validate)(shared_1.MaxNumberLength, [5])
], UpdateDeviceV2.prototype, "merrcoMerchantTerminalNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "merrcoApiAuthKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)()
], UpdateDeviceV2.prototype, "deviceMetadata", void 0);
//# sourceMappingURL=deviceV2.js.map